export const getProductsCheckedStatus = (products) => ({
    isEveryNotAdded: products.every((product) => !product.checked),
    isSomeNotAdded: products.some((product) => !product.checked),
    isEveryAdded: products.every((product) => product.checked),
    isSomeAdded: products.some((product) => product.checked),
});
export const getCheckedStatusById = (products, id) => products.find((product) => product.id === id)?.checked;
